
export default {
    name: "cal-registration-dialog-steps",
    props: ["steps", "showRegistrationDialog", "onSubmit", "showFooterActions", "sliderSize"],
    data() {
        return {
            showSlideOver: false,
            currentTab: 0,
            disableTabChange: false,
        };
    },
    computed: {
        size() {
            return this.steps.length - 1;
        }
    },
    watch: {
        showRegistrationDialog() {
            this.showSlideOver = this.showRegistrationDialog;
        },
    },
    created() {
        this.$nuxt.$on("disableContinue", (status) => {
            this.disableTabChange = status;
        });
    },
    methods: {
        moveToNext() {
            if (this.currentTab < this.size) {
                this.currentTab++;
            }
        },
        backToPrevious() {
            if (this.currentTab != 0) {
                this.currentTab--;
                this.$nuxt.$emit("toBack");
            }
        },
        closeRegistrationSlideOver() {
            this.showSlideOver = false;
            this.$emit("closeRegistrationSlideOver");
        },
        submit() {
            if (this.onSubmit) {
                this.onSubmit();
                return;
            }
            this.showSlideOver = false;
        },
    },
    beforeUnmount() {
        this.$nuxt.$off("tabChange");
        this.$nuxt.$off("toBack");
        this.$nuxt.$off("disableContinue");
    },
};
